var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewIdentificationType } from "./view";
import LocalStorageService from "../../services/localStorage";
import { identificationTypePatchClearData, identificationTypePostClearData, } from "../../store/identificationType/actions";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { useIdentificationTypeGetAll } from "../../fnx/identificationType/identificationTypeGetAll";
import { useIdentificationTypePost } from "../../fnx/identificationType/identificationTypePost";
import { useIdentificationTypePatch } from "../../fnx/identificationType/identificationTypePatch";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { themeCore } from "../../assets/themes/theme";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { identificationTypeDataForm } from "./identificationTypeDTO";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var IdentificationTypeAdmin = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(1), page = _a[0], setPage = _a[1];
    var _b = useState(20), limit = _b[0], setLimit = _b[1];
    var _c = useState(0), countPagination = _c[0], setCountPagination = _c[1];
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(false), triggerPost = _e[0], setTriggerPost = _e[1];
    var _f = useState(false), triggerPatch = _f[0], setTriggerPatch = _f[1];
    var _g = useState([]), list = _g[0], setList = _g[1];
    var _h = useState(false), openModal = _h[0], setOpenModal = _h[1];
    var _j = useState(false), openModalDelete = _j[0], setOpenModalDelete = _j[1];
    var _k = useState(false), openModalCloneConfirm = _k[0], setOpenModalCloneConfirm = _k[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _l = useState(false), isUpdate = _l[0], setIsUpdate = _l[1];
    var _m = useState(false), openDrawer = _m[0], setOpenDrawer = _m[1];
    var _o = useState(null), itemModal = _o[0], setitemModal = _o[1];
    var _p = useState(""), nameSearch = _p[0], setNameSearch = _p[1];
    var _q = useState(), bodyRequest = _q[0], setBodyRequest = _q[1];
    var _r = useState(identificationTypeDataForm), dataForm = _r[0], setDataForm = _r[1];
    var _s = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _s[0], setSeeToast = _s[1];
    var _t = useIdentificationTypeGetAll(trigger, nameSearch, nameSearch, page, limit), responseIdentificationType = _t.responseIdentificationType, errorIdentificationType = _t.errorIdentificationType, loadingIdentificationType = _t.loadingIdentificationType;
    var _u = useIdentificationTypePost(triggerPost, bodyRequest), responsePostIdentificationType = _u.responsePostIdentificationType, errorPostIdentificationType = _u.errorPostIdentificationType, loadingPostIdentificationType = _u.loadingPostIdentificationType;
    var _v = useIdentificationTypePatch(triggerPatch, bodyRequest), responsePatchIdentificationType = _v.responsePatchIdentificationType, errorPatchIdentificationType = _v.errorPatchIdentificationType, loadingPatchIdentificationType = _v.loadingPatchIdentificationType;
    var _w = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _w.responseDeleteEntity, loadingDeleteEntity = _w.loadingDeleteEntity, errorDeleteEntity = _w.errorDeleteEntity;
    var isNumericOptions = [
        { id: 1, name: "Si", value: "1" },
        { id: 2, name: "No", value: "2" },
    ];
    useEffect(function () {
        if (!(responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data)) {
            setTrigger(true);
        }
    }, []);
    useEffect(function () {
        if (responseIdentificationType && (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data)) {
            var newList = responseIdentificationType.data.map(function (item) { return ({
                id: item.id,
                title: item.description,
                code: item.code,
                maxCharacter: item.maxCharacter,
                minCharacter: item.minCharacter,
                isNumeric: item.isNumeric,
                clientId: item.clientId,
            }); });
            setList(newList);
            setTrigger(false);
        }
        if (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.pagingInfo) {
            setCountPagination(responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.pagingInfo.totalItems);
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        if (responsePostIdentificationType &&
            (responsePostIdentificationType === null || responsePostIdentificationType === void 0 ? void 0 : responsePostIdentificationType.data)) {
            showToastSuccessMessage("Creado con éxito.", typeAlert.success, setSeeToast);
            dispatch(identificationTypePostClearData());
        }
        else if (errorPostIdentificationType) {
            showErrorToast(errorPostIdentificationType, setSeeToast, t);
        }
        setTriggerPost(false);
        setTrigger(true);
    }, [responsePostIdentificationType, errorPostIdentificationType]);
    useEffect(function () {
        if (responseDeleteEntity) {
            showToastSuccessMessage("Eliminado con éxito.", typeAlert.success, setSeeToast);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (responsePatchIdentificationType) {
            setOpenDrawer(false);
            showToastSuccessMessage("Actualizado con éxito.", typeAlert.success, setSeeToast);
            setTriggerPatch(false);
            dispatch(identificationTypePatchClearData());
        }
        else if (errorPatchIdentificationType) {
            showErrorToast(errorPatchIdentificationType, setSeeToast, t);
            setTriggerPatch(false);
        }
        setTrigger(true);
    }, [responsePatchIdentificationType, errorPatchIdentificationType]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    useEffect(function () {
        if (nameSearch) {
            setTrigger(true);
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var filterStatus = function (item) {
        var idSponsor = item === null || item === void 0 ? void 0 : item.sponsor.map(function (item) { return item.id; }).join(",");
        setTrigger(true);
    };
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { id: row.id, clientId: row.clientId, Description: row.title, Code: row.code, MaxCharacter: row.maxCharacter, MinCharacter: row.minCharacter, IsNumeric: row.isNumeric }));
    };
    var handleSubmit = function (data, file) {
        if (isUpdate) {
            setBodyRequest({
                data: {
                    id: data.id,
                    clientId: data.clientId,
                    description: data.Description,
                    code: data.Code,
                    maxCharacter: data.MaxCharacter,
                    minCharacter: data.MinCharacter,
                    isNumeric: data.isNumeric === 1 ? true : false,
                },
            });
            setTriggerPatch(true);
        }
        else {
            setBodyRequest({
                data: {
                    description: data.Description,
                    code: data.Code,
                    maxCharacter: data.MaxCharacter,
                    minCharacter: data.MinCharacter,
                    isNumeric: data.isNumeric === 1 ? true : false,
                },
            });
            setTriggerPost(true);
        }
        setOpenDrawer(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setDataForm(__assign(__assign({}, dataForm), { id: "", clientId: "", Description: "", Code: "", MaxCharacter: 0, MinCharacter: 0, IsNumeric: true }));
        setIsUpdate(false);
        setOpenDrawer(true);
    };
    var onClickContextMenu = function (opt, item) {
        switch (opt.id) {
            case "1":
                setIsUpdate(true);
                setOpenDrawer(true);
                showEdit(item);
                break;
            case "2":
                setOpenModalDelete(true);
                setitemModal(item);
                break;
            case "3":
                setitemModal(item);
                setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    var handleDelete = function () {
        setOpenModalDelete(false);
        dispatch(deleteEntity({
            id: itemModal.id,
            entity: "IdentificationTypeEntity",
            idUser: clientId,
        }));
    };
    var handleClone = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
        dispatch(identificationTypePostClearData());
    };
    var onCloseDrawer = function () {
        setDataForm(__assign(__assign({}, dataForm), { id: "", clientId: "", Description: "", Code: "", MaxCharacter: 0, MinCharacter: 0, IsNumeric: false }));
        setOpenDrawer(false);
    };
    var onChangeRowsPerPage = function (e) {
        setLimit(e);
        setTrigger(true);
    };
    var onChangePage = function (e) {
        setPage(e);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: loadingIdentificationType ||
                    loadingPostIdentificationType ||
                    loadingPatchIdentificationType ||
                    loadingDeleteEntity, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: loadingDeleteEntity
                    ? "Eliminando Tipo de Identificacion"
                    : "Cargando Tipo de Identificacion...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(ViewIdentificationType, { loadingPost: loadingPostIdentificationType, list: list, openModal: openModal, openModalCloneConfirm: openModalCloneConfirm, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, isNumericOptions: isNumericOptions, onClickContextMenu: onClickContextMenu, onCloseSearch: onCloseSearch, searchFilter: searchFilter, filterStatus: filterStatus, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onSaveData: handleSubmit, onClickAdd: handleOnClickAdd, editMode: isUpdate, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, openModalDelete: openModalDelete, setOpenModalDelete: setOpenModalDelete, onCloseDrawer: onCloseDrawer, page: page, limit: limit, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage, countPagination: countPagination })] }));
};
export default IdentificationTypeAdmin;
